function isFieldValueValid(type: string, value: any): boolean {
  if (type === 'date_range') {
    if (!value || typeof value !== 'object') return false
    if (value.relative !== undefined && value.relative !== '') return !!value.unit
    return !!value.from || !!value.to
  }
  if (type === 'number_range') {
    if (!value || typeof value !== 'object') return false
    if (value.operator === 'between') return value.min !== '' && value.min != null && value.max !== '' && value.max != null
    return !!value.operator && value.value !== '' && value.value != null
  }
  return !!value
}

export default function validateRule(
  rule: {
    type: 'filter' | 'group'
    id: string
    parameters?: Record<string, any>
    ruleIds?: Array<typeof id>
    filter: string
  },
  availableFilters: Map<string, { fields: Record<string, any> }>,
  allRules: Array<typeof rule>
): boolean {
  const { id, type, parameters, ruleIds, filter } = rule

  if (type === 'filter') {
    const fields = availableFilters[filter].fields
    const requiredFields = _.pickBy(fields, (f) => !f.optional)
    const optionalFields = _.pickBy(fields, (f) => f.optional)
    const numRequired = _.keys(requiredFields).length

    // If no required fields and no expanded optional fields, valid
    if (numRequired === 0 && _.keys(parameters).length === 0) return true

    // Check all required fields are present and valid
    const requiredValid = _.every(requiredFields, (fieldConfig, fieldName) => {
      const value = parameters[fieldName]
      return isFieldValueValid(fieldConfig.type, value)
    })

    // Check all expanded optional fields are valid
    const expandedOptionalValid = _.every(optionalFields, (fieldConfig, fieldName) => {
      if (parameters[fieldName] === undefined) return true
      return isFieldValueValid(fieldConfig.type, parameters[fieldName])
    })

    return requiredValid && expandedOptionalValid
  }
  if (type === 'group') {
    if (allRules.some((r) => r.ruleIds?.indexOf(id) > -1)) {
      return ruleIds.length > 0
    }
    return true
  }
  return false
}
